import React from "react";
import MemberAds from "../Member/MemberAds";

const AdminAdsPage: React.FC = () => {
  return (
    <div className="w-full">
      <div className="w-full h-[74px] p-4">
        <div className="mx-1 flex items-end">
          <div className="flex flex-1">
            <h1 className="text-gray-900 font-bold text-4xl">Manage Ads</h1>
          </div>
        </div>
      </div>
      <MemberAds />
    </div>
  );
};

export default AdminAdsPage;
